import { makeTextControl } from './makeTextControl';

export const Input = makeTextControl<HTMLInputElement>('input');
